import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowsLeftRight, X } from '@phosphor-icons/react';
import { useCompare } from '../lib/compareStore';

export const CompareBar = () => {
  const { list, remove, clear } = useCompare();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (list.length === 0 || pathname === '/compare' || pathname.startsWith('/admin')) return null;

  return (
    <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-1.5rem)] max-w-2xl bg-[#0B1220]/90 backdrop-blur-xl border border-cyan-500/40 rounded-full shadow-2xl shadow-cyan-500/10 pl-4 pr-1.5 py-1.5 flex items-center gap-2 animate-in slide-in-from-bottom-4" data-testid="compare-bar">
      <div className="hidden sm:flex flex-1 min-w-0 gap-1.5 overflow-x-auto">
        {list.map((p) => (
          <span key={p.slug} className="inline-flex shrink-0 items-center gap-1 bg-[#1E293B] rounded-full px-2 py-0.5 text-[11px] font-mono text-cyan-300">
            {p.name}
            <button onClick={() => remove(p.slug)} className="text-[#94A3B8] hover:text-white" aria-label={`Remove ${p.name}`} data-testid={`compare-bar-remove-${p.slug}`}>
              <X size={11} />
            </button>
          </span>
        ))}
      </div>
      <span className="sm:hidden flex-1 text-[11px] font-mono text-[#94A3B8]">{list.length < 2 ? 'Pick 1 more to compare' : `${list.length} selected`}</span>
      <button onClick={clear} className="text-xs font-mono text-[#94A3B8] hover:text-white px-2" data-testid="compare-bar-clear-btn">Clear</button>
      <button
        onClick={() => navigate(`/compare?slugs=${list.map((p) => p.slug).join(',')}`)}
        disabled={list.length < 2}
        title={list.length < 2 ? 'Select at least 2 modules' : undefined}
        className="shrink-0 inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-400 disabled:opacity-40 disabled:cursor-not-allowed text-[#05050A] font-mono font-bold text-xs rounded-full px-4 py-2 transition-colors"
        data-testid="compare-bar-open-btn"
      >
        <ArrowsLeftRight size={14} weight="bold" /> Compare ({list.length})
      </button>
    </div>
  );
};

export default CompareBar;
